/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
import {
  AnalyticsContext,
} from '@gcc/adobe-analytics';
import AnalyticsConstants from './constants';
import { sites } from '../helpers/globalVariables';

// TODO: delete this function and utilize the new GCC.NPM.AdobeAnalytics package
export const buildBaseEventData = (primaryCategory, eventName) => {
  const baseObject = {
    category: { primaryCategory },
    eventInfo: { eventName },
  };

  return baseObject;
};

// TODO: delete this function and utilize the new GCC.NPM.AdobeAnalytics package
export const buildBcomAnalyticsEvent = (primaryCategory, eventName, sku = null) => {
  const eventData = buildBaseEventData(primaryCategory, eventName);

  if (sku) {
    eventData.item = [{ productInfo: { sku } }];
  }

  return eventData;
};

export const createProductInfoProperty = (sku) => {
  const productInfo = {
    sku,
  };
  return productInfo;
};

export const createItemPropertyForContainer = (items, containerId) => {
  const itemsInContainer = items.allIds
    .filter(id => items.byId[id].containerId === containerId && items.byId[id].itemProduct);

  const item = itemsInContainer.map((id) => {
    const productInfo = createProductInfoProperty(items.byId[id].itemProduct.skuNumber);
    return { productInfo };
  });

  return item;
};

export const getProductToBeSwappedKey = designId => `productToBeSwapped-${designId}`;

export const getSkuOfProductToBeSwapped = (designId) => {
  const productToBeSwappedKey = getProductToBeSwappedKey(designId);
  const productToBeSwapped = localStorage.getItem(productToBeSwappedKey);
  return productToBeSwapped;
};

export const getAppropriateProductIdForSite = (siteId, autobahnProductId, partnerProductId) => (siteId === sites.theHomeDepot ? partnerProductId : autobahnProductId);

export const createAndSendButtonSubmissionAnalyticsEventForSingleSku = (siteId, sku, eventName) => {
  const analyticsContext = new AnalyticsContext(siteId);
  const productInfo = createProductInfoProperty(sku);
  const item = [{ productInfo }];
  const buttonSubmissionAnalyticsEvent = analyticsContext.createButtonSubmissionEventWithEventNameAndItem(eventName, item);
  analyticsContext.sendAnalyticsEvent(buttonSubmissionAnalyticsEvent);
};

export const createAndSendButtonSubmissionAnalyticsEventForMultipleSkus = (
  items,
  containerId,
  siteId,
  eventName,
) => {
  const analyticsContext = new AnalyticsContext(siteId);
  const item = createItemPropertyForContainer(items, containerId);
  const buttonSubmissionAnalyticsEvent = analyticsContext.createButtonSubmissionEventWithEventNameAndItem(eventName, item);
  analyticsContext.sendAnalyticsEvent(buttonSubmissionAnalyticsEvent);
};

export const createAndSendProductRemovedAnalyticsEventIfSwappingProduct = (designId, siteId) => {
  const skuOfProductToBeSwapped = getSkuOfProductToBeSwapped(designId);
  if (skuOfProductToBeSwapped) {
    createAndSendButtonSubmissionAnalyticsEventForSingleSku(
      siteId,
      skuOfProductToBeSwapped,
      AnalyticsConstants.EventNames.DesignRemoveProduct,
    );
    localStorage.removeItem(getProductToBeSwappedKey(designId));
  }
};

export const createAndSendButtonSubmissionEventWithEventName = (siteId, eventName) => {
  const analyticsContext = new AnalyticsContext(siteId);
  const buttonSubmissionAnalyticsEvent = analyticsContext.createButtonSubmissionEventWithEventName(eventName);
  analyticsContext.sendAnalyticsEvent(buttonSubmissionAnalyticsEvent);
};

export const createAndSendPageLoadEvent = (
  siteId,
  pageName,
  pageType,
  primaryCategory,
  subCategory1,
  subCategory2,
) => {
  const analyticsContext = new AnalyticsContext(siteId);
  const pageObject = analyticsContext.createPageObject(
    pageName,
    pageType,
    primaryCategory,
    subCategory1,
    subCategory2,
  );

  const betaSite = '';
  const experienceType = window.device.type;
  const siteObject = analyticsContext.createSiteObject(betaSite, experienceType, siteId);
  analyticsContext.sendPageLoadEvent(pageObject, siteObject);
};
